import {useNavigate, useSearchParams} from "react-router-dom";
import {operatingAreaSelector, useGetOperatingAreaQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {OperatingAreaProfile} from "../../components/profile/OperatingAreaProfile/OperatingAreaProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const OperatingAreaProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.operatingarea", "Operating Area") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <OperatingAreaProfilePage id={id}/>;
};

export const OperatingAreaProfilePage = (props: Props) => {
  const {id} = props;

  const selectOperatingArea = useMemo(() => {
    return operatingAreaSelector()
  }, []);

  const {operatingArea, isFetching} = useGetOperatingAreaQuery(id ?? skipToken, {
    selectFromResult: (result) => ({
      operatingArea: selectOperatingArea(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage entity={operatingArea} isLoading={isFetching} permissions={["view", "operatingarea_view"]}>
      {(entity) => (
        <OperatingAreaProfile operatingArea={entity}/>
      )}
    </EntityProfilePage>
  )
};
